// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-search-wrapper {
  position: relative;
}

/* Ensure autocomplete panel appears above all menus */
::ng-deep .global-search-panel {
  z-index: 2000 !important;
}

/* Match data-grid .filter-input exactly, but larger */
.filter-input {
  border-radius: 4px;
  font-size: 15px;
  padding: 10px 14px;
  border: 1px solid #ced4da;
  background-color: white;
  height: auto;
}
.filter-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.filter-input::placeholder {
  color: #6c757d;
  font-style: italic;
}
.filter-input.border-start-0 {
  border-left: none;
}

.input-group-text {
  border: 1px solid #ced4da;
  border-right: none;
  border-radius: 4px 0 0 4px;
  padding: 10px 12px;
  gap: 6px;
  align-items: center;
}

.search-icon-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.search-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #6c757d;
  vertical-align: middle;
}

.search-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.search-option-name {
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.search-option-meta {
  flex-shrink: 0;
}

.outcome-badge {
  background-color: #e8f0fe;
  color: #0066B2;
  font-size: 0.75em;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/global-search/global-search.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA,sDAAA;AACA;EACE,wBAAA;AACF;;AAEA,sDAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;AACF;AACE;EACE,qBAAA;EACA,UAAA;EACA,gDAAA;AACJ;AAEE;EACE,cAAA;EACA,kBAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AAFF","sourcesContent":[".global-search-wrapper {\n  position: relative;\n}\n\n/* Ensure autocomplete panel appears above all menus */\n::ng-deep .global-search-panel {\n  z-index: 2000 !important;\n}\n\n/* Match data-grid .filter-input exactly, but larger */\n.filter-input {\n  border-radius: 4px;\n  font-size: 15px;\n  padding: 10px 14px;\n  border: 1px solid #ced4da;\n  background-color: white;\n  height: auto;\n\n  &:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n\n  &::placeholder {\n    color: #6c757d;\n    font-style: italic;\n  }\n\n  &.border-start-0 {\n    border-left: none;\n  }\n}\n\n.input-group-text {\n  border: 1px solid #ced4da;\n  border-right: none;\n  border-radius: 4px 0 0 4px;\n  padding: 10px 12px;\n  gap: 6px;\n  align-items: center;\n}\n\n.search-icon-slot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n}\n\n.search-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  color: #6c757d;\n  vertical-align: middle;\n}\n\n.search-option-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.search-option-name {\n  font-weight: 500;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.search-option-meta {\n  flex-shrink: 0;\n}\n\n.outcome-badge {\n  background-color: #e8f0fe;\n  color: #0066B2;\n  font-size: 0.75em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
